<template>
  <div class="wrap">
    <Swiper class="swiper_c" />
    <Content></Content>
  </div>
</template>

<script>
import Swiper from "./Swiper";
import Content from "./componenets/content.vue";
export default {
  name: "about",
  components: {
    Swiper,
    Content,
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.swiper_c {
  width: 100%;
  height: 500px;
}
</style>